import { FC } from 'react'

import { FieldProps as FormikFieldProps } from 'formik'
import { AnyObjectSchema } from 'yup'

import { TextField, TextFieldProps } from '@themenu/design-system'

import { fieldInput } from '@app/components/Form/styles'
import { isRequiredField } from '@app/utils/isRequiredField'

export type FormikFieldInputProps = TextFieldProps & FormikFieldProps & { validationSchema?: AnyObjectSchema }

export const FormikFieldInput: FC<FormikFieldInputProps> = ({ form, field, validationSchema, className, ...props }) => {
  const isRequired = validationSchema ? isRequiredField({ validationSchema, fieldName: field.name }) : props.required

  return (
    <TextField
      size={56}
      required={isRequired}
      error={form?.touched[field.name] !== undefined && form?.errors[field.name] !== undefined}
      errorMessage={(form?.errors[field.name] as string) || ''}
      {...field}
      {...props}
      className={fieldInput({ readonly: props.readonly, className: [className] })}
      id={field.name}
    />
  )
}
